import lottie from 'lottie-web';
import djAnimationData from '../animations/dark_json.json';
import ljAnimationData from '../animations/light_json.json';

document.addEventListener('DOMContentLoaded', () => {
    const darkContainer = document.getElementById('lottie-logo-dark');
    if (darkContainer) {
        lottie.loadAnimation({
            container: darkContainer, // Элемент, куда вставляется анимация
             renderer: 'svg',      // Рендеринг через SVG
             loop: true,           // Зацикливание анимации
             autoplay: true,       // Автоматический старт
             animationData: djAnimationData.animation, // Данные анимации
        });
    }

    const lightContainer = document.getElementById('lottie-logo-light');
    if (lightContainer) {
        lottie.loadAnimation({
            container: lightContainer, // Элемент, куда вставляется анимация
             renderer: 'svg',      // Рендеринг через SVG
             loop: true,           // Зацикливание анимации
             autoplay: true,       // Автоматический старт
             animationData: ljAnimationData.animation, // Данные анимации
        });
    }
});
